// @flow
import React from 'react';
import { ProductSignatures } from 'Components/widgets/product-signatures/ProductSignatures.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {|
  id: string,
  imageSrc: string,
  header: string,
  text: string,
  tail: string,
|};

export function ProductSignaturesLine({ id, ...props }: Props) {
  return (
    <SiteContainer id={id} className="Line">
      <ProductSignatures {...props} />
    </SiteContainer>
  );
}
